
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/language";

interface ReadMoreButtonProps {
  expanded: boolean;
  toggleExpand: () => void;
}

const ReadMoreButton = ({ expanded, toggleExpand }: ReadMoreButtonProps) => {
  const { language } = useLanguage();
  
  return (
    <Button 
      variant="ghost" 
      size="sm" 
      onClick={toggleExpand}
      className="mt-2 p-0 h-auto text-primary font-normal hover:bg-transparent"
    >
      {expanded ? (
        language === 'ja' ? '閉じる' : 
        language === 'es' ? 'Mostrar menos' : 
        language === 'zh' ? '收起' :
        'Show less'
      ) : (
        language === 'ja' ? 'もっと読む' : 
        language === 'es' ? 'Leer más' : 
        language === 'zh' ? '阅读更多' :
        'Read more'
      )}
    </Button>
  );
};

export default ReadMoreButton;
